import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";

import { AfterViewInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";

import { merge, Observable, of as observableOf } from "rxjs";
import { catchError, map, startWith, switchMap } from "rxjs/operators";
import { Dossier } from '../../core/model/dossier';


@Component({
  selector: 'app-vue-static',
  templateUrl: './vue-static.component.html',
  styleUrls: ['./vue-static.component.scss']
})
export class VueStaticComponent implements OnInit {


  dossiers: Dossier[];

  displayedColumns: string[] = [
    "numDossier",
    "typeDossier",
    "nomClient",
    "montantPret",
    "resteAPayer",
    "dateMiseEnPlace",
    "statutDossier",
    "impayeJour",
    "actions",
  ];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  
  constructor(
    private modalService: NgbModal,
    private _router: Router
  ) {}

  ngOnInit(): void {

    this.dossiers = [
      {
          "logImport": {
              "id": "ba7ced4c-517b-46ba-a8b9-e857c45c1858",
              "active": true,
              "nomFichier": "mise_en_place_particulier_1 (3) (1).xlsx",
              "directory": "mise_en_place",
              "dateTelechargement": "2023-10-13T16:17:35.995274Z",
              "dateImportation": "2023-10-13T16:20:36.037026200Z",
              "nbLigneTrouve": "5",
              "nbLigneImporte": "5",
              "downloadBy": "chargeaffaire10",
              "importBy": "chargeaffaire10",
              "status": "IMPORTE"
          },
          "id": "7",
          "numDossier": "X0712770",
          "codeClient": "X8330340",
          "montantPret": 450000.0,
          "dateMiseEnPlace": "2023-01-06 00:00:00",
          "impayeJour": 180,
          "resteAPayer": 450000.0,
          "nomClient": "DIARRASSOUBA AMARA",
          "codeAgence": "14201",
          "codeGestionnaire": null,
          "typeDossier": "PARTICULIER",
          "statutDossier": {
              "id": "2",
              "code": "DECLASSE",
              "libelle": "Déclassé"
          },
          "estContamine": null,
          "longitude": null,
          "latitude": null,
          "localisation": null,
          "codeAgentEconomique": "Particulier",
          "segmentationClient": "CLIENTELE DE DETAIL"
      },
      {
          "logImport": {
              "id": "4263d4c4-4f62-4ab7-92b6-d5cee6973714",
              "active": true,
              "nomFichier": "mise_en_place_particulier.xlsx",
              "directory": "mise_en_place_particulier",
              "dateTelechargement": "2023-08-11T11:09:35.280632600Z",
              "dateImportation": "2023-08-11T11:13:06.831666800Z",
              "nbLigneTrouve": "4",
              "nbLigneImporte": "4",
              "downloadBy": "chargeaffaire10",
              "importBy": "chargeaffaire10",
              "status": "IMPORTE"
          },
          "id": "2",
          "numDossier": "X071277",
          "codeClient": "X0833034        ",
          "montantPret": 450000.0,
          "dateMiseEnPlace": "2022-01-06 00:00:00",
          "impayeJour": 334.0,
          "resteAPayer": 450000.0,
          "nomClient": "ASSI ATTE MULER                                                    ",
          "codeAgence": "14201",
          "codeGestionnaire": null,
          "typeDossier": "PARTICULIER",
          "statutDossier": {
              "id": "2",
              "code": "DECLASSE",
              "libelle": "Déclassé"
          },
          "estContamine": null,
          "longitude": null,
          "latitude": null,
          "localisation": null,
          "codeAgentEconomique": "Particulier",
          "segmentationClient": "CLIENTELE DE DETAIL"
      },
      {
          "logImport": {
              "id": "ba7ced4c-517b-46ba-a8b9-e857c45c1858",
              "active": true,
              "nomFichier": "mise_en_place_particulier_1 (3) (1).xlsx",
              "directory": "mise_en_place",
              "dateTelechargement": "2023-10-13T16:17:35.995274Z",
              "dateImportation": "2023-10-13T16:20:36.037026200Z",
              "nbLigneTrouve": "5",
              "nbLigneImporte": "5",
              "downloadBy": "chargeaffaire10",
              "importBy": "chargeaffaire10",
              "status": "IMPORTE"
          },
          "id": "8",
          "numDossier": "X0712640",
          "codeClient": "X13316590",
          "montantPret": 270000.0,
          "dateMiseEnPlace": "2023-01-06 00:00:00",
          "impayeJour": 190,
          "resteAPayer": 270000.0,
          "nomClient": "ARSENE GOHORE BI",
          "codeAgence": "35201",
          "codeGestionnaire": null,
          "typeDossier": "PARTICULIER",
          "statutDossier": {
              "id": "2",
              "code": "DECLASSE",
              "libelle": "Déclassé"
          },
          "estContamine": null,
          "longitude": null,
          "latitude": null,
          "localisation": null,
          "codeAgentEconomique": "Particulier",
          "segmentationClient": "CLIENTELE DE DETAIL"
      }
    ]

    this.isLoadingResults = false;
    this.isRateLimitReached = false;
    this.resultsLength = 3;
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
  }

  voirEcheance(numDossier): void {

  }


}
